import {myChannelsApi} from '@/api/my-channels.api.js'
import {platformTypes} from '@/constants/address-types.js'
import {useTeams} from '@/composables/use-teams.js'
import {ref} from 'vue'

/**
 * Channel management composable
 */
export function useChannelManagement(channel) {

  //Composables
  const {isInTeams} = useTeams()

  //Updating channel flag
  const isUpdatingChannel = ref(false)

  //Update unread state
  const updateIsUnread = async isUnread => {

    //Must have channel with ID
    if (!channel.value?.id) {
      throw new Error(`Must have channel with ID`)
    }

    //Extract data
    const {id} = channel.value
    const platformLastInteractedOn = isInTeams.value ? platformTypes.TEAMS : platformTypes.WEB

    //Toggle flag
    isUpdatingChannel.value = true

    //Update
    try {
      await myChannelsApi.updateById(id, {isUnread, platformLastInteractedOn})
    }
    finally {
      isUpdatingChannel.value = false
    }
  }

  //Expose interface
  return {
    updateIsUnread,
    isUpdatingChannel,
  }
}
